import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
// import CommissaryAddCategory from "./CommissaryAddCategory";
// import CommissaryCategoryEdit from "./CommissaryCategoryEdit";
import { UserInfo } from "../../../../context";
import AddProductCategory from "./AddProductCategory";
import ProductCategoryEdit from "./ProductCategoryEdit";

const ProductCategory = () => {
  const [commissaryList, setCommissaryList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Date Created",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getCommissaryProductCategory = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/product-category-list", { params })
      .then((response) => {
        const data = response.data;
        setCommissaryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getCommissaryProductCategory();
  }, [getCommissaryProductCategory]);

  const searchable = commissaryList.data.filter((data) => {
    return data.category.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            placeholder="Search product category"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
        >
          Add Category
        </Button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddProductCategory
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getCommissaryProductCategory={() => getCommissaryProductCategory()}
        />
      )}

      {editDrawer && (
        <ProductCategoryEdit
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getCommissaryProductCategory={() => getCommissaryProductCategory()}
          selectedData={selectedData}
        />
      )}
    </>
  );
};

export default ProductCategory;
